import {Paper, Stack, Text, Title} from '@mantine/core';
import React from 'react';

export default function MigrationPreviewSection({
  title,
  description,
  children,
}: {
  title: string;
  description?: string;
  children?: React.ReactNode;
}): JSX.Element {
  return (
    <Paper withBorder={true} p="md" radius="md">
      <Stack spacing="sm">
        <Title order={5}>{title}</Title>
        {description != null && (
          <Text size="sm" color="dimmed">
            {description}
          </Text>
        )}
        {children}
      </Stack>
    </Paper>
  );
}
